import { render, staticRenderFns } from "./DOTSPatientReferList.vue?vue&type=template&id=09dc29b0"
import script from "./DOTSPatientReferList.vue?vue&type=script&lang=js"
export * from "./DOTSPatientReferList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports